import { render, staticRenderFns } from "./OtpCode.vue?vue&type=template&id=9ed28fe2&scoped=true&"
import script from "./OtpCode.vue?vue&type=script&lang=js&"
export * from "./OtpCode.vue?vue&type=script&lang=js&"
import style0 from "./OtpCode.vue?vue&type=style&index=0&id=9ed28fe2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ed28fe2",
  null
  
)

export default component.exports